import React from 'react'
import Fragment from '../common/fragment'


function FragmentBH(props) {
  return (
    <Fragment pos="hh" {...props}>
      <p>
      Señora de las Abejas:
      Zumba en torno al Muñeco de Cera,

      Trae una multitud de tus hijas
      Que hagan la miel más dulce
      En el lugar más amargo
      </p>
    </Fragment>
  )
}


export default FragmentBH
